// src/components/ui/badge.jsx

import * as React from 'react';
import { cn } from '@lib/utils';

const badgeVariants = {
  default: 'sl-badge-default bg-primary-100 text-primary-800',
  secondary: 'sl-badge-secondary bg-gray-100 text-gray-800',
  success: 'sl-badge-success bg-green-100 text-green-800',
  warning: 'sl-badge-warning bg-yellow-100 text-yellow-800',
  error: 'sl-badge-error bg-red-100 text-red-800',
  outline: 'sl-badge-outline border border-gray-200 text-gray-800',
};

const Badge = React.forwardRef(
  ({ className, variant = 'default', children, ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(
          'sl-badge',
          'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
          badgeVariants[variant],
          className,
        )}
        {...props}>
        {children}
      </span>
    );
  },
);

Badge.displayName = 'Badge';

export { Badge, badgeVariants };
